import JoinNavbar from "./components/JoinNavbar";
import JoinForm from "./components/JoinForm";

export default function Join() {
  return (
    <div className="min-h-screen bg-beige">
      <JoinNavbar />
      <div className="pt-24 pb-16 md:pt-32 md:pb-24">
        <JoinForm />
      </div>
    </div>
  );
}
